import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { duration, easing } from "../../../design-system/tokens/transitions";

export const Field = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  width: 100%;
  padding: ${spacing[2]} ${spacing[4]};
  background: ${rawColors.structural.white};
  border: 1px solid ${rawColors.grey[200]};
  border-radius: 200px;
  box-sizing: border-box;
  transition: border-color ${duration.fast} ${easing.smooth};

  &:focus-within {
    border-color: ${rawColors.primary[500]};
  }
`;

export const Icon = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  color: ${rawColors.text.lowEmphasis};
`;

export const Input = styled.input`
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  padding: 0;
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.highEmphasis};

  &::placeholder {
    ${typographyMixin("caption", 4)}
    color: ${rawColors.text.lowEmphasis};
  }

  &::-webkit-search-cancel-button {
    display: none;
  }
`;
